export default __webpack_public_path__ + "static/media/Rectangle 1057.4b434d67.png";